<template>
  <div>Root Hub template - to be migrated</div>
</template>
